export const MODAL_NAME = 'orders.create-backship-labels'
